import { Response } from './Response';

export const mapResponse = function <T>({ data }: { data: T }): Response<T> {
  return { isSuccess: true, data: data, errorMessage: null, errorCode: null };
};
